import { gql, useMutation } from '@apollo/client';
import { PROJECT_PAGE_FRAGMENT } from '../gql/projectPageFragment';
import { useIntl, defineMessages } from 'react-intl';
import toast from 'helpers/toast';
import { useCallback } from 'react';
import { get } from 'lodash';

const SHARE_PROJECT_PAGE = gql`
  mutation ShareProjectPage($input: ShareProjectPageInput!) {
    shareProjectPage(input: $input) {
      errors {
        error
        message
      }
      page {
        __typename
        ...ProjectPageFragment
      }
    }
  }
  ${PROJECT_PAGE_FRAGMENT}
`;

const messages = defineMessages({
  shareProjectPageError: {
    id: 'ProjectPage.hooks.shareProjectPageError',
    defaultMessage: 'This was an error sharing the project note page',
    description: 'Graphql error message for sharing a project note page',
  },
});

const useShareProjectPage = () => {
  const { formatMessage } = useIntl();

  const [shareProjectPageMutation] = useMutation(SHARE_PROJECT_PAGE, {
    onCompleted: (res) => {
      const errors = get(res, 'shareProjectPage.errors', null);
      if (errors.length) {
        toast.error(formatMessage(messages.shareProjectPageError));
      }
    },
    onError: () => {
      toast.error(formatMessage(messages.shareProjectPageError));
    },
  });

  const shareProjectPage = useCallback(
    (pageId) =>
      shareProjectPageMutation({
        variables: {
          input: {
            pageId,
          },
        },
      }),
    [shareProjectPageMutation],
  );

  return {
    shareProjectPage,
  };
};

export default useShareProjectPage;
